import { useApp, useTriggerAction, useUpdateWidgetValue } from '@libs/hooks';
import { ActionActionTypeEnum, TWidget, TWidgetProps } from '@libs/types';
import React, { useCallback } from 'react';
import { TBalanceData, TConsumerListData } from '../../types/data';
import { ListEnum, RowEnum } from '../../types/enums';
import { TListOption } from '../../types/options';
import { ButtonRow } from '../Buttons/ButtonRow';
import { ListSelect } from '../List/select/ListSelect';
import { PopupComponent } from '../UI/Popup/PopupComponent';
import { convertBalanceInToListItem } from './utils/balanceUtils';

type TBalanceBottonSheetProps = {
    value: string;
} & TWidgetProps<TBalanceData>;
const SelectBalanceBottomSheet: React.FC<TBalanceBottonSheetProps> = ({ widget, value }) => {
    const { triggerActionsByNameAndType } = useTriggerAction(widget);
    const { updateWidgetValue } = useUpdateWidgetValue(widget);
    const { setPopup } = useApp();
    const data = widget.data ?? {};
    const messages = data.messages ?? {};
    const isShowBalances = data.balances?.length > 1;

    const buttonClickHandel = useCallback(
        (actionName: string) => {
            triggerActionsByNameAndType(ActionActionTypeEnum.onClick, actionName).then();
            setPopup(null);
        },
        [setPopup, triggerActionsByNameAndType],
    );

    const getButtons = () => {
        const buttons = [];
        if (data.canAddCurrency) {
            buttons.push(
                <ButtonRow
                    isWidget={false}
                    as={'button'}
                    handleClick={() => buttonClickHandel('addAnotherCurrency')}
                    label={messages.addBalanceButtonTitle}
                    iconName={'ic_plus'}
                />,
            );
        }
        if (data.canExchange) {
            buttons.push(
                <ButtonRow
                    isWidget={false}
                    as={'button'}
                    handleClick={() => buttonClickHandel('exchange')}
                    label={messages.exchangeButtonTitle}
                    iconName={'ic_arrows_recurring'}
                />,
            );
        }
        if (data.canGetPaysendCard) {
            buttons.push(
                <ButtonRow
                    isWidget={false}
                    as={'button'}
                    handleClick={() => buttonClickHandel('getPaysendCard')}
                    label={messages.getCardButtonTitle}
                    iconName={'ic_card_plus'}
                />,
            );
        }
        return buttons;
    };

    const getBalances = (balanceWidget: TWidget<TBalanceData>) => {
        const widgetList: TWidget<TConsumerListData, TListOption> = {
            ...balanceWidget,
            id: ListEnum.SELECT,
            alternativeId: ListEnum.SELECT,
            data: {
                value: value,
                items: convertBalanceInToListItem(balanceWidget.data.balances, value as string),
            },
            widgets: [],
        };
        return (
            <ListSelect
                widget={widgetList}
                rowId={RowEnum.SELECTOR_REGULAR}
                isOpenInModal
                onSelectItem={(_uid, item) => {
                    updateWidgetValue(item.value);
                    setPopup(null);
                }}
            />
        );
    };

    return (
        <PopupComponent
            header={isShowBalances ? messages?.selectBalanceTitle : false}
            internalContent={isShowBalances ? getBalances(widget) : false}
            externalContent={getButtons()}
        />
    );
};

export default SelectBalanceBottomSheet;
